import { RouterOutputs, trpc } from "../trpc";
import { keepPreviousData } from "@tanstack/react-query";
import { AppsOrder } from "@zapier/bff";
export type PublicApp = RouterOutputs["app"]["publicApps"]["results"][number];

interface Input {
  limit?: number;
  offset?: number;
  ordering?: AppsOrder;
  search?: string;
}

interface Options {
  enabled?: boolean;
}

export function useQueryPublicApps(
  { limit = 25, offset = 0, search, ordering }: Input,
  { enabled }: Options = {},
) {
  const { data, isFetching, isLoading } = trpc.app.publicApps.useQuery(
    {
      limit,
      offset,
      search,
      ordering,
    },
    {
      enabled,
      placeholderData: keepPreviousData,
      staleTime: Infinity, // Apps don't change often, only refetch on user action
      trpc: {
        context: {
          // Skip batching to avoid bundling this critical procedure with slower requests
          skipBatching: true,
        },
      },
    },
  );

  return {
    totalCount: data?.count || 0,
    apps: (data?.results || []) as any[],
    isLoading,
    isFetching,
  };
}
